import React from 'react';

import { type FTemplateSectionFragment, type FWaypointTemplateFragment } from '@dashboard/generated/wp/platform';
import { Paper, Typography } from '@mui/material';

import TemplateSummaryCard from './TemplateSummaryCard';

type TemplateDragOverlayProps = {
  template: FWaypointTemplateFragment | null;
};

export function TemplateDragOverlay({ template }: TemplateDragOverlayProps) {
  if (template === null) {
    return null;
  }
  return <TemplateSummaryCard template={template} />;
}

type SectionDragOverlayProps = {
  section: FTemplateSectionFragment | null;
  sectionsWidth: number | null;
};

export function SectionDragOverlay({ section, sectionsWidth }: SectionDragOverlayProps) {
  if (section === null) {
    return null;
  }
  return (
    <Paper
      variant="outlined"
      sx={{
        width: sectionsWidth ?? 100,
        px: 1.5,
        py: 0.75,
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor: 'background.paper',
      }}
    >
      <Typography variant="overline" color="text.secondary" fontWeight="medium">
        {section.name}
      </Typography>
    </Paper>
  );
}
